import { render, staticRenderFns } from "./PriorAuthorization.vue?vue&type=template&id=4e15b442&"
import script from "./PriorAuthorization.vue?vue&type=script&lang=js&"
export * from "./PriorAuthorization.vue?vue&type=script&lang=js&"
import style0 from "./PriorAuthorization.vue?vue&type=style&index=0&id=4e15b442&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports